function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "inbound");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-vessel-arrival",
  transform: "translate(-4.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M19,20 L5,20 C4.44771525,20 4,20.4477153 4,21 C4,21.5522847 4.44771525,22 5,22 L19,22 C19.5522847,22 20,21.5522847 20,21 C20,20.4477153 19.5522847,20 19,20 Z M11.29,17.71 C11.3851037,17.8010406 11.4972487,17.8724056 11.62,17.92 C11.8620399,18.0269768 12.1379601,18.0269768 12.38,17.92 C12.5027513,17.8724056 12.6148963,17.8010406 12.71,17.71 L16.71,13.71 C17.1021222,13.3178778 17.1021222,12.6821222 16.71,12.29 C16.3178778,11.8978778 15.6821222,11.8978778 15.29,12.29 L13,14.59 L13,3 C13,2.44771525 12.5522847,2 12,2 C11.4477153,2 11,2.44771525 11,3 L11,14.59 L8.71,12.29 C8.45634143,12.0363414 8.08662601,11.9372765 7.74012195,12.0301219 C7.3936179,12.1229674 7.12296742,12.3936179 7.03012194,12.740122 C6.93727646,13.086626 7.03634142,13.4563414 7.29,13.71 L11.29,17.71 Z",
  id: "inbound"
})));

var SvgInbound = function SvgInbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inbound.a1a402fa.svg";
export { ForwardRef as ReactComponent };